export default __webpack_public_path__ + "static/media/icon-piece-jointe-blanc.f2f007d2.svg";